import { Graph } from '../core/graph';
import { serializeDocument } from '../core/serialize';
import { applyPreset, findPreset } from './presets';

export interface StarterTemplate {
  id: string;
  name: string;
  description: string;
  image?: string;
}

/** Templates shown before the editor launches. Images are replaced by saved previews once edited. */
export const STARTER_TEMPLATES: StarterTemplate[] = [
  {
    id: 'blank',
    name: 'Blank texture',
    description: 'An empty graph ready for your first node.',
  },
  {
    id: 'brick-wall',
    name: 'Brick wall',
    description: 'Aged running-bond brick with heavy mortar overflow, damp staining, and wear.',
    image: '/docs/images/brick-wall.png',
  },
  {
    id: 'rusted-metal',
    name: 'Rusted metal',
    description: 'Pitted steel with rust blooming through low areas.',
    image: '/docs/images/rusted-metal.png',
  },
  {
    id: 'cracked-earth',
    name: 'Cracked earth',
    description: 'Dry plates, deep cracks, and dusty colour variation.',
    image: '/docs/images/cracked-earth.png',
  },
  {
    id: 'hex-scales',
    name: 'Hex scales',
    description: 'Layered hexagonal scales with relief and edge definition.',
    image: '/docs/images/hex-scales.png',
  },
];

/** Build a cloud-ready document without starting WebGL or the editor. */
export function starterDocument(templateId: string): { name: string; body: string } {
  const template = STARTER_TEMPLATES.find((item) => item.id === templateId);
  if (!template) throw new Error(`Unknown template "${templateId}"`);

  const graph = new Graph();
  if (templateId === 'blank') graph.setName('Untitled texture');
  else {
    const preset = findPreset(templateId);
    if (!preset) throw new Error(`Template "${templateId}" is unavailable`);
    applyPreset(graph, preset);
    graph.setName(template.name);
  }
  return { name: graph.name, body: serializeDocument(graph.toJSON()) };
}
